import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Stack/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(marketing)/launch/waldorfastoria/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AldarLogo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonTransition/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonWrapper/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/CustomContainer/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Desktop"] */ "/app/src/components/Desktop/Desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Mobile"] */ "/app/src/components/Mobile/Mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ParallaxBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ParallaxText/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfBackdrop/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfBackdropCarousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfBanner/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfCompany/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfContainer/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfDesigned/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfDesignedSlider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfDistinctive/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfDistinctiveSlider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfFooter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfHeader/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfLogo/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfPartnership/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfRegisterTheme/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfRegistration/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfSpecification/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/launch-components/WaldorfAstoriaLaunch/WaldorfWelcome/index.tsx");
